import { Injectable } from '@angular/core';
import { Config } from '../config';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ReservationDto } from '../models';

@Injectable({
  providedIn: 'root'
})
export class ReservationTenantService {

  constructor(
    private config: Config,
    private http: HttpClient
  ) { }


  getReservations(filter): Observable<ReservationDto[]> {
    return this.http.post<ReservationDto[]>(this.config.get('API_SERVER_URL') + '/reservation/list', filter);
  }

  addReservation(reservation: ReservationDto): Observable<HttpResponse<void>> {
    return this.http.put<HttpResponse<void>>(this.config.get('API_SERVER_URL') + '/reservation', reservation);
  }

  cancelReservation(idReservation: number): Observable<HttpResponse<void>> {
    return this.http.delete<HttpResponse<void>>(this.config.get('API_SERVER_URL') + `/reservation/${idReservation}`);
  }

  getPermittedCompanies(): Observable<any[]> {
    return this.http.get<any[]>(this.config.get('API_SERVER_URL') + '/reservation/tenants');
  }

  getReservation(idReservation: number): Observable<ReservationDto> {
    return this.http.get<ReservationDto>(this.config.get('API_SERVER_URL') + `/reservation/details/${idReservation}`);
  }
}
